import { ResponseData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface SubmitScoreResponse extends ResponseData {
    type: '@stemcstudio/gradebook:submit-score-response';
}

/**
 * @hidden
 */
export function isSubmitScoreResponse(message: MessageEvent): message is MessageEvent<SubmitScoreResponse> {
    const duck = message as MessageEvent<SubmitScoreResponse>;
    if (duck.data.type && duck.data.type === '@stemcstudio/gradebook:submit-score-response') {
        return true;
    } else {
        return false;
    }
}
